import assetPath from '/app/xinglets/entity-pages/subpage/about-us/src/components/facts/assets/website.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')